import AppSystemResourceModel from '../../generated/types/model/resource/AppSystemResourceModel';

export default class AppSystemResourceViewModel extends AppSystemResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
